namespace TabAurous.Purchase {
    export namespace ApprovalInReturnPostingService {
        export const baseUrl = 'Purchase/ApprovalInReturnPosting';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Common.MasterTransaction>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/ApprovalInReturnPosting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ApprovalInReturnPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
